//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import TikTokUserId from '@models/TikTokUserId';

export interface ITikTokUser {
  id: TikTokUserId;
  audienceCountries: ITikTokAudienceCountry[];
  audienceGenders: ITikTokAudienceGender[];
  dailyMetrics: ITikTokDailyUserMetric[];
  displayName?: string;
  followersCount?: number;
  profileImage?: string;
  username?: string;
}

export interface ITikTokAudienceCountry {
  country?: string;
  percentage?: number;
}

export interface ITikTokAudienceGender {
  gender?: TikTokGender;
  percentage?: number;
}

export enum TikTokGender {
  Male = 'Male',
  Female = 'Female',
  Other = 'Other',
}

export interface ITikTokDailyUserMetric {
  date?: Date;
  audienceActivity: ITikTokAudienceActivity[];
  commentCount?: number;
  followersCount?: number;
  likeCount?: number;
  profileViews?: number;
  shareCount?: number;
  videoViews?: number;
}

export interface ITikTokAudienceActivity {
  hour?: string;
  count?: number;
}

export interface IGetTikTokUserResponse {
  data: ITikTokUser;
}
